angular.module('env.customConfig.styles', [
    'env.customConfig.provider',
    'env.customConfig.logicResolvers',
    'env.custom.customModule'
])

    .config(function ($customisationConfigProvider, $customLogicResolversProvider) {
        $customisationConfigProvider.styles =
            [
                {
                    name: "login-css-override",
                    resolve: function (context) {
                        //context object for login-screen-band will be of the form: { user: %currentUserObject% }

                        //For Autodesk branded site when we do need lower band on login screen
                        //The path isn't calculated as this needs serving directly before the customisation system has fully started
                        return "customise/css/" + this.name + "/" + this.name + ".css";

                        //For Delcam branded site when we don't need lower band on login screen
                        //return "";
                    }
                },
                {
                    name: "customers-orders-stats",
                    resolve: function (context) {
                        //context object for custom css will be of the form: { user: %currentUserObject% }

                        //The path isn't calculated as this needs serving directly before the customisation system has fully started
                        return "customise/html/customers/customers.css";
                    }
                },
                {
                    name: "order-files-css-override",
                    resolve: function (context) {
                        //context object for order-files-css-override will be of the form: { user: %currentUserObject% }

                        return "customise/css/" + this.name + "/" + this.name + ".css";
                    }
                },
                {},
                {}
            ];
    })

;
